var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    { attrs: { id: _vm.id, options: _vm.options } },
    [
      _vm.title
        ? _c(
            "h2",
            { staticClass: "font-semibold text-center text-gray-800 mb-3" },
            [_vm._v(" " + _vm._s(_vm.title) + " ")]
          )
        : _vm._e(),
      _c("p", { staticClass: "text-center text-gray-700 mb-4" }, [
        _vm._v(" " + _vm._s(_vm.message) + " ")
      ]),
      _c(
        "BaseButton",
        {
          staticClass:
            "uppercase font-semibold text-primary-700 self-center hover:bg-black-overlay",
          on: { click: _vm.close }
        },
        [_vm._v(" Ok ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }